import { render } from "./PackagesManagerOrdersRealisationView.vue?vue&type=template&id=02230410&scoped=true"
import script from "./PackagesManagerOrdersRealisationView.vue?vue&type=script&lang=js"
export * from "./PackagesManagerOrdersRealisationView.vue?vue&type=script&lang=js"

import "./PackagesManagerOrdersRealisationView.vue?vue&type=style&index=0&id=02230410&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02230410"]])

export default __exports__